import { render } from "./ShortURL.vue?vue&type=template&id=7faa5a7a"
import script from "./ShortURL.vue?vue&type=script&lang=js"
export * from "./ShortURL.vue?vue&type=script&lang=js"
script.render = render

export default script